import { desktop } from '@hg/stylizator/utils'
import parse, { attributesToProps, domToReact, Element, HTMLReactParserOptions } from 'html-react-parser'
import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'
import styled, { css } from 'styled-components'

const options: HTMLReactParserOptions = {
  trim: true,
  replace: (domNode) => {
    if (domNode instanceof Element && domNode.attribs) {
      const props = attributesToProps(domNode.attribs)
      const children = domToReact(domNode.children, options)

      if (domNode.name === 'figure') {
        return <>{children}</>
      }

      if (domNode.name === 'img') {
        return <img {...props} loading="lazy" />
      }
    }

    return domNode
  },
}

const BlockImageBlock: React.FC<IWPGBlock> = (props) => {
  const attrs = props.attrs as { align?: string }

  return <Figure align={attrs.align}>{parse(props.innerHTML, options)}</Figure>
}

export default BlockImageBlock

const Figure = styled.figure<{ align?: string }>`
  float: left;
  mix-blend-mode: multiply;

  img {
    width: 100%;
    height: auto;
  }

  ${(props) => props.align === 'left' && alignLeft}
  ${(props) => props.align === 'center' && alignCenter}
  ${(props) => props.align === 'right' && alignRight}
`

const alignCenter = css`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 40px;

  @media ${desktop} {
    margin-top: 56px;
  }
`

const alignLeft = css`
  margin: 24px 24px 24px 0;
`

const alignRight = css`
  float: right;
  margin: 24px 0 24px 24px;
`
